module.exports = __webpack_public_path__ + "static/jixiao-ef9d9cb878c519f1b245d95f2f8effa4.png";